import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserAuth, AuthState, CheckedUser } from '@handover/shared-types';

const initialState: AuthState = {
  userAuth: null,
  checkedUser: null,
};

const authSlice = createSlice({
  name: 'userAuth',
  initialState,
  reducers: {
    setAuthState: (
      state,
      action: PayloadAction<{
        userAuth: UserAuth;
      }>
    ) => {
      state.userAuth = action.payload.userAuth;
    },
    logout: state => {
      state.userAuth = null;
      state.checkedUser = null;
    },
    setCheckedUser: (state, action: PayloadAction<CheckedUser | null>) => {
      state.checkedUser = action.payload;
    },
  },
});

export const { setAuthState, logout, setCheckedUser } = authSlice.actions;

export default authSlice.reducer;
